export default __webpack_public_path__ + "static/media/les-logos.fdfc7965.jpg";